module.exports = __webpack_public_path__ + "img/JE.c5dfac37.png";